import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Checkout.css';

const Checkout = () => {
  const [searchParams] = useSearchParams();

  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    amount: '',
    description: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const product = searchParams.get('product');
    const amount  = searchParams.get('amount');
    if (product) setForm(prev => ({ ...prev, description: product }));
    if (amount)  setForm(prev => ({ ...prev, amount }));
  }, [searchParams]);

  const handle = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch('/pay.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          currency: 'MWK',
          callback_url: `${window.location.origin}/payment-success`,
          return_url:   `${window.location.origin}/payment-success`,
        }),
      });

      const data = await res.json();

      if (data?.data?.checkout_url) {
        window.location.href = data.data.checkout_url;
      } else {
        setError(data?.message || 'Payment initiation failed. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  const displayPrice = searchParams.get('display_price');

  return (
    <section className="section checkout-page">
      <div className="container">
        <h1 className="section-title">Checkout</h1>
        <p className="checkout-intro">
          Fill in your details below to complete your order. You will be redirected
          to a secure payment page.
        </p>

        <div className="checkout-wrap">
          <form className="checkout-form" onSubmit={handleSubmit}>

            {form.description && (
              <div className="checkout-summary">
                <span className="summary-label">Ordering:</span>
                <span className="summary-product">{form.description}</span>
                {displayPrice && <span className="summary-price">{displayPrice}</span>}
                {searchParams.get('size') && <span className="summary-size">Size: {searchParams.get('size')}</span>}
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="first_name">First Name</label>
                <input id="first_name" name="first_name" type="text"
                  value={form.first_name} onChange={handle} required />
              </div>
              <div className="form-group">
                <label htmlFor="last_name">Last Name</label>
                <input id="last_name" name="last_name" type="text"
                  value={form.last_name} onChange={handle} required />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input id="email" name="email" type="email"
                value={form.email} onChange={handle} required />
            </div>

            <div className="form-group">
              <label htmlFor="description">What are you ordering?</label>
              <input id="description" name="description" type="text"
                placeholder="e.g. Custom suit, 2 printed t-shirts…"
                value={form.description} onChange={handle} />
            </div>

            <div className="form-group">
              <label htmlFor="amount">Amount (MWK)</label>
              <input id="amount" name="amount" type="number" min="1"
                placeholder="e.g. 150000"
                value={form.amount} onChange={handle} required />
            </div>

            {error && <p className="checkout-error">{error}</p>}

            <button type="submit" className="checkout-btn" disabled={loading}>
              {loading ? 'Processing…' : 'Proceed to Payment'}
            </button>
          </form>

          <div className="checkout-info">
            <h3>Payment Info</h3>
            <p>We accept payments via <strong>Paychangu</strong> — including mobile money and card.</p>
            <p>Your payment is processed on a secure, encrypted page.</p>
            <p>After payment you will be redirected back to confirm your order.</p>
            <div className="checkout-contact">
              <p>Questions? Call us:</p>
              <a href="tel:+265884996996">+265 884 996 996</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Checkout;
